var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isABoardByReference
        ? _c("FiltersForBoardByReference", {
            on: {
              "on-the-fly-filters-change": function($event) {
                _vm.onTheFlyFilters = $event
              }
            }
          })
        : _vm._e(),
      _vm.isSuperBoard
        ? _c("FiltersForSuperBoard", {
            on: {
              "on-server-filters-change": _vm.onServerFiltersChange,
              "on-the-fly-filters-change": function($event) {
                _vm.onTheFlyFilters = $event
              }
            }
          })
        : _vm._e(),
      _vm.isMyBoard
        ? _c("FiltersForMyBoard", {
            on: {
              "on-server-filters-change": _vm.onServerFiltersChange,
              "on-the-fly-filters-change": function($event) {
                _vm.onTheFlyFilters = $event
              }
            }
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "row mx-n1 vh-content flex-nowrap overflow-x-scroll" },
        [
          _vm._l(_vm.columns, function(column) {
            return _c(
              "Column",
              {
                key: column.id,
                attrs: { column: column, "show-actions": !!_vm.referenceId },
                on: { "create-activity": _vm.onCreateActivityAction }
              },
              [
                _c("ColumnContent", {
                  attrs: {
                    "data-id": column.id,
                    "column-value": column.value,
                    "column-name": column.name,
                    "kanban-id": _vm.kanbanId,
                    "on-the-fly-filters": _vm.onTheFlyFilters
                  },
                  on: { "select-activity": _vm.onSelectActivityAction }
                })
              ],
              1
            )
          }),
          _c("ActivitySidebar", {
            attrs: {
              show: _vm.sidebarConfig.show,
              config: _vm.sidebarConfig,
              "kanban-id": _vm.kanbanId,
              "reference-id": _vm.referenceId,
              "reference-type": _vm.referenceType,
              "reference-number": _vm.referenceNumber,
              "activity-id": _vm.selectedActivity.id
            },
            on: { close: _vm.onCloseSidebar }
          }),
          _c("b-overlay", {
            attrs: { show: _vm.columnsLoading, "no-wrap": "" }
          })
        ],
        2
      ),
      !_vm.columnsLoading
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Descargar como CSV",
                  expression: "'Descargar como CSV'"
                }
              ],
              staticClass: "position-fixed download-button"
            },
            [
              _c(
                "div",
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "badge-glow",
                      attrs: { "data-cy": "download-list", variant: "warning" },
                      on: { click: _vm.downloadData }
                    },
                    [
                      _c("feather-icon", {
                        attrs: { icon: "DownloadIcon", size: "20" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }